import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { openMembershipCheckout } from "@/lib/razorpay";

/**
 * One place for the "Join Course" action: signs the visitor in if needed, starts
 * the Razorpay membership (₹100 for 21 days, then ₹251/month) and verifies it.
 */
export function useJoinCourse() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [joining, setJoining] = useState(false);

  const join = async () => {
    if (!user) {
      toast.info("Please sign in first — it takes a moment");
      nav("/login", { state: { next: "/yoga/dashboard" } });
      return;
    }
    setJoining(true);
    try {
      const { data: session } = await api.post("/yoga/subscribe");
      if (session.note) toast.info(session.note);
      await openMembershipCheckout({
        session,
        prefill: { name: user.name, email: user.email, contact: user.phone || "" },
        onSuccess: async (resp) => {
          try {
            await api.post("/yoga/subscribe/verify", resp);
            toast.success("You're in! Day 1 is ready for you.");
            nav("/yoga/dashboard");
          } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail));
          }
        },
        onFailure: (msg) => toast.error(msg),
        onDismiss: () => toast.info("Payment window closed — you can join any time"),
      });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setJoining(false);
    }
  };

  return { join, joining };
}
